import React, { useMemo } from "react"
import PropTypes from "prop-types"
import Spinner from "components/common/Spinner"
import { useSelector } from "react-redux"
import styles from "../../../Calendar.module.css"
import CalendarTimeGrid from "../../CalendarTimeGrid"

const Day = ({ date, experienceIds, crewIds, equipmentIds, activeTab }) => {
  const { loading, bookings } = useSelector((state) => state.calendar)
  const allExperiences = useSelector((state) => state.experiences?.list || [])

  const events = useMemo(() => {
    return bookings?.map((booking) => ({
      id: booking?.uuid,
      start: booking?.start_time,
      end: booking?.end_time,
      title: booking?.experience_name,
      date: booking?.date,
      payment_status: booking?.payment_status,
      booking_status: booking?.booking_status,
      resource: booking?.experience_name,
      experience_id: booking?.experience_id,
      assigned_crew: booking?.assigned_crew || [],
      assigned_equipment: booking?.assigned_equipment || [],
    }))
  }, [bookings])

  const resources = useMemo(() => {
    // Crew, equipment, or unassigned filter active — derive columns from the already-filtered bookings
    if (crewIds?.length > 0 || equipmentIds?.length > 0) {
      const encounteredIds = new Set()
      return events
        .filter((ev) => {
          if (!ev.experience_id || encounteredIds.has(ev.experience_id)) return false
          encounteredIds.add(ev.experience_id)
          return true
        })
        .map((ev) => ({ id: ev.experience_id, title: ev.resource }))
    }

    // Experience filter active
    if (experienceIds?.length > 0) {
      return allExperiences
        .filter((exp) => experienceIds.includes(exp.id))
        .map((exp) => ({ id: exp.id, title: exp.title }))
    }

    // No filter — show all experiences
    return allExperiences.map((exp) => ({ id: exp.id, title: exp.title }))
  }, [allExperiences, events, experienceIds, crewIds, equipmentIds])

  return (
    <>
      <CalendarTimeGrid date={date} events={events} type="day" resources={resources} crewIds={crewIds} equipmentIds={equipmentIds} activeTab={activeTab} />
      {loading && <Spinner className={styles.spinner} absolute />}
    </>
  )
}

Day.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  experienceIds: PropTypes.array,
  crewIds: PropTypes.array,
  equipmentIds: PropTypes.array,
  activeTab: PropTypes.string,
}

export default Day
